<div class="inbox-header">
	<div class="page-title d-inline">Inbox</div>
	<div class="d-inline float-right">
		<cv-dropdown class="d-inline-block me-1"
			[placeholder]="'Global filter'"
			[icon]="'fa-filter'"
			[optionText]="'label'"
			[options]="globalFilterOptions"
			[selectedValue]="defaultGlobalFilter"
			(valuesChange)="onGlobalFilterChange($event)">
		</cv-dropdown>
		<button
			class="btn btn-sm cv-btn-light"
			title="Refresh Inbox"
			(click)="reloadInbox()">
			<i class="fa fa-sync-alt"></i>
			<span>Update list</span>
		</button>
	</div>
</div>
